<script>
import {
  BaseLabelColor,
  BaseLabelShade,
} from '@/shared/constants/baseComponents/baseLabel'

import BookingStatusLabelType from '@/shared/constants/booking/BookingStatusLabelType'

export default {
  name: 'BookingStatusLabel',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      BaseLabelShade,
    }
  },
  computed: {
    statusLabel() {
      if (!Object.values(BookingStatusLabelType).includes(this.status)) {
        return 'unknown'
      }
      return this.status
    },
    labelColor() {
      const {
        InProgress,
        Pending,
        Confirmed,
        Cancelled,
        Open,
        Unapproved,
      } = BookingStatusLabelType
      const { yellow, purple, green, grey } = BaseLabelColor

      switch (this.status) {
        case InProgress:
        case Open:
          return yellow
        case Pending:
          return purple
        case Confirmed:
          return green
        case Cancelled:
        case Unapproved:
          return grey
        default:
          return grey
      }
    },
  },
}
</script>

<template>
  <BaseLabel
    :text="statusLabel"
    :color="labelColor"
    :shade="BaseLabelShade.light"
  />
</template>
